import React, { useState, useEffect } from "react";
import ElementTitle from "ui/crfs/element_title";
import DividerLine from "ui/crfs/divider_line";
import styles from "./blood_test_result.module.css";
import RadioGroupUI from "ui/crfs/radio_group/components/radio_group_ui";
import IntUI from "ui/crfs/int/components/int_ui";
import DecimalUI from "ui/crfs/decimal/components/decimal_ui";
import DataCompleteChangeModal from "ui/crfs/data_complete_change_modal";
import EntryRuleOverrideModal from "ui/crfs/entry_rule_override_modal";
import { cloneDeep } from "lodash";
import ElementMenu from "ui/crfs/element_menu";
import LoadingButton from "@mui/lab/LoadingButton";

let tempStorage = null;
export default function BloodTestResult(props) {
  const {
    field,
    field_id,
    title,
    options,
    instruction,
    instruction_color,
    sub_title,
    onUpdate,
    enableQuery,
    setQuery,
    query,
    crf_id,
    subject_id,
    domain_id,
    calcUpdateToCrfStatus,
    crfStatus,
    read_only,
    toggleHistory,
    selected_audit_icon,
    setQueryModalData,
  } = props;

  const [localVal, setLocalVal] = useState(field.value_obj || {});
  const [showingCompleteChangeModal, setShowingCompleteChangeModal] = useState(false);
  const [showingEntryOverrideModal, setShowingEntryOverrideModal] = useState(false);
  const [dataChange, setDataChange] = useState(false);

  useEffect(() => {
    tempStorage = field.value_obj;
  }, [field.value_obj]);

  useEffect(() => {
    setLocalVal(field.value_obj);
  }, [field]);

  const acceptTempStorage = (reason) => {
    commonUpdateValueActions(localVal, reason);
    tempStorage = localVal;
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setDataChange(false);
  };
  const closeModal = () => {
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setLocalVal(tempStorage);
    setDataChange(false);
  };

  const commonUpdateValueActions = (value, reason = null) => {
    delete field?.value_obj.missing;
    delete value.missing;
    // if (value.length === 4) {
    onUpdate({
      data_id: field?.value_obj?.data_id || null,
      flags: field?.value_obj?.flags || null,
      ...value,
      reason,
      value_name: field.value_name,
      value2_name: field.value2_name,
      value3_name: field.value3_name,
      value4_name: field.value4_name,
    });
    // } else {
    //   setLocalVal(tempStorage);
    // }
  };

  const updateValue = (position, value_obj, error_override = false) => {
    if (entry_rule_error(position) && !error_override) {
      if (field.entry_rule_override) {
        setShowingEntryOverrideModal(true);
      } else {
        setLocalVal(tempStorage);
        setDataChange(false);
      }
      return;
    } else {
      commonUpdateValueActions(localVal);
      setDataChange(false);
    }
  };

  const entry_rule_error = (value_pos) => {
    let error = false;
    if (value_pos === "value2" && localVal?.value2 && field.entry_rules && dataChange) {
      field.entry_rules?.some((rule) => {
        if (rule.rule_type === "int_min") {
          if (parseInt(localVal.value2) < parseInt(rule.value)) {
            error = `Must be greater than or equal to ${rule.value}`;
            return error;
          }
        } else if (rule.rule_type === "int_max") {
          if (parseInt(localVal.value2) > parseInt(rule.value)) {
            error = `Must be less than or equal to ${rule.value}`;
            return error;
          }
        }
      });
    } else if (value_pos === "value3" && localVal?.value3 && field.entry_rules && dataChange) {
      field.entry_rules?.some((rule) => {
        if (rule.rule_type === "decimal_min") {
          if (parseFloat(localVal.value3) < parseFloat(rule.value)) {
            error = `Must be greater than or equal to ${rule.value}`;
            return error;
          }
        } else if (rule.rule_type === "decimal_max") {
          if (parseFloat(localVal.value3) > parseFloat(rule.value)) {
            error = `Must be less than or equal to ${rule.value}`;
            return error;
          }
        }
      });
    }
    return error;
  };

  const onChange = (value, value_pos) => {
    if (!dataChange) {
      tempStorage = localVal;
    }
    setLocalVal({ ...localVal, [value_pos]: value });
    setDataChange(true);
  };

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles.left_split}>
          <ElementTitle required={field.required} title={title} />
        </div>
        <div className={styles.right_split}>
          <div className={styles.flex_column}>
            {field?.options?.is_available ? (
              <div className={styles.inner_row}>
                <div className={styles.inner_row_title}>Result available:</div>
                {read_only || field.read_only ? (
                  <div>
                    {["yes", "no"].includes(field.value_obj.value)
                      ? field.value_obj.value.toLowerCase() === "yes"
                        ? "Yes"
                        : "No"
                      : "--"}
                  </div>
                ) : (
                  <RadioGroupUI
                    {...props}
                    onUpdate={(value_obj) => {
                      let obj = { ...localVal, value: value_obj.value };
                      if (value_obj.value !== "yes") {
                        obj.value2 = null;
                        obj.value3 = null;
                        obj.value4 = null;
                      }
                      setLocalVal(obj);
                      commonUpdateValueActions(obj);
                    }}
                    field={{ ...field, value_obj: localVal }}
                    options={[
                      { label: "Yes", value: "yes" },
                      { label: "No", value: "no" },
                    ]}
                    value_position={"value"}
                    value_name_position={"value_name"}
                  />
                )}
              </div>
            ) : null}
            {field?.options?.int_value && (!field?.options?.is_available || field?.value_obj?.value === "yes") ? (
              <div className={styles.inner_row}>
                <div className={styles.inner_row_title}>Value:</div>
                {read_only ? (
                  <div>
                    {field.value_obj.value2} {field.options.int_value.units}
                  </div>
                ) : (
                  <div className={styles.flex_column}>
                    <div className={styles.flex_row}>
                      <IntUI
                        {...props}
                        value={localVal.value2 || ""}
                        onChange={(value2) => onChange(value2, "value2")}
                        onUpdate={() => updateValue("value2", localVal)}
                        field={{ ...field, value_obj: localVal }}
                        value_position={"value2"}
                        value_name_position={"value2_name"}
                        units={field.options.int_value.units || ""}
                        length={field.options.int_value.max_length || 2}
                        disabled={localVal?.value !== "yes"}
                      />
                    </div>
                    <div className={styles.flex_row}>
                      {entry_rule_error("value2").constructor === String ? (
                        <div className={styles.input_flex}>
                          <div className={styles.error}>{entry_rule_error("value2")}</div>

                          {field.entry_rule_override ? (
                            <LoadingButton
                              variant="outlined"
                              loading={false}
                              onClick={() => updateValue(true)}
                              sx={{
                                fontSize: 14,
                                padding: "2px",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              Save Anyway
                            </LoadingButton>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>
            ) : null}
            {field?.options?.decimal_value && (!field?.options?.is_available || field?.value_obj?.value === "yes") ? (
              <div className={styles.inner_row}>
                <div className={styles.inner_row_title}>Value:</div>
                {read_only ? (
                  <div>
                    {field.value_obj.value3 || "---"} {field.options.decimal_value.units}
                  </div>
                ) : (
                  <div className={styles.flex_column}>
                    <div className={styles.flex_row}>
                      <DecimalUI
                        {...props}
                        value={localVal.value3 || ""}
                        field={{ ...field, value_obj: localVal }}
                        onChange={(value3) => onChange(value3, "value3")}
                        onUpdate={() => updateValue("value3", localVal)}
                        value_position={"value3"}
                        value_name_position={"value3_name"}
                        units={field.options.decimal_value.units || ""}
                        whole_length={field.options.decimal_value.whole_length}
                        decimal_length={field.options.decimal_value.decimal_length}
                        disabled={localVal?.value !== "yes"}
                      />
                    </div>
                    <div className={styles.flex_row}>
                      {entry_rule_error("value3").constructor === String ? (
                        <div className={styles.input_flex}>
                          <div className={styles.error}>{entry_rule_error("value3")}</div>

                          {field.entry_rule_override ? (
                            <LoadingButton
                              variant="outlined"
                              loading={false}
                              onClick={() => updateValue(true)}
                              sx={{
                                fontSize: 14,
                                padding: "2px",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              Save Anyway
                            </LoadingButton>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>
            ) : null}
            {field?.options?.units_value && (!field?.options?.is_available || field?.value_obj?.value === "yes") ? (
              <div className={styles.inner_row}>
                <div className={styles.inner_row_title}>Unit:</div>
                {read_only ? (
                  <div>{field.value_obj.value4 || "---"}</div>
                ) : (
                  <RadioGroupUI
                    {...props}
                    field={{ ...field, value_obj: localVal }}
                    onUpdate={(value_obj) => {
                      let obj = { ...localVal, value4: value_obj.value4 };
                      setLocalVal(obj);
                      commonUpdateValueActions(obj);
                    }}
                    options={field.options.units_value}
                    value_position={"value4"}
                    value_name_position={"value4_name"}
                    disabled={localVal?.value !== "yes"}
                  />
                )}
              </div>
            ) : null}
            {field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}
          </div>
          <div className={styles.audit_icon}>
            <ElementMenu
              {...props}
              field={field}
              selected={selected_audit_icon}
              setQueryModalData={setQueryModalData}
            />
          </div>
        </div>
      </div>

      <DividerLine />
      <DataCompleteChangeModal isOpen={showingCompleteChangeModal} close={closeModal} onYes={acceptTempStorage} />
      <EntryRuleOverrideModal isOpen={showingEntryOverrideModal} close={closeModal} onYes={acceptTempStorage} />
    </div>
  );
}
